import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const RANGE_SCHEMA = Object.freeze({
  OFFSET: 0,
  LENGTH: 0,
});
const RECORD = generateSchema(RANGE_SCHEMA);
const KEYS: any = generateKeys(RANGE_SCHEMA);

export class Range extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get offset(): number {
    return this.get(KEYS.OFFSET);
  }

  get rangeLength(): number {
    return this.get(KEYS.LENGTH);
  }
}
